import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DeviceDetectorService, DeviceInfo } from 'ngx-device-detector';
import { retry, timeout, switchMap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import {
  AlertasService,
  AuditService,
  CargandoService,
  ComboComponent,
  Environment,
  GenericService,
  LoginService,
  TemaService,
  VariableLocalSesionService,
} from 'new-sysman-ui';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    FormsModule,
    MatTooltipModule,
    MatIcon,
    ComboComponent,
  ],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, AfterViewInit {
  deviceInfo: DeviceInfo;
  estado = 'usuario';
  /*Variable que se encarga de hacer la contraseña visible */
  ocultarContrasena = false;
  /*Variable que almacena la contraseña */
  txtPass = '';
  /*Variable que almacena el nombre del usuario */
  /*Variable en la cual se almacenara el listado de compañias */
  listaCompanias: any;
  /* Variable en la que se obtiene el usuario para ser mostrado en la forma */
  /* Variable que almacena la opcion elegida por el usuario en la forma */
  codigoCompania: any;
  /*Variable que limita la carga de la vista */
  consultando = true;
  /* Varuable en la cual se va almacenar la el usuario */
  txtUsuario = '';
  /* Variable usada para agregar el focus a el input */
  txtU: any;
  environment!: Environment;
  /*Variable en la cual se almacena la url del servicio con el cual se obtienen las url del modulo autenciacion */
  usuario = '';
  nombreusuario = '';
  @ViewChild('txtU', { static: false })
  txtuser!: ElementRef;
  @ViewChild('txtU', { static: true })
  txtP!: ElementRef;
  combocompanias_url = '';
  combocompanias_claveseleccion = 'codigo';
  combocompanias_params: any;
  datacompania: any;
  /*Variable que almacena la cantidad de compañias que tiene el usuario */
  cantidadcompanias = 0;
  urlServicioGeneral!: string;
  constructor(
    private readonly router: Router,
    public Http: HttpClient,
    private readonly rutaActiva: ActivatedRoute,
    private readonly mensajeria: AlertasService,
    private readonly servicioCargando: CargandoService,
    private readonly generalService: GenericService,
    private readonly variablesSesion: VariableLocalSesionService,
    private readonly tema: TemaService,
    private readonly translate: TranslateService,
    private readonly loginService: LoginService,
    private readonly auditoriaServicio: AuditService,
    private readonly deviceDetectorService: DeviceDetectorService,
  ) {
    this.deviceInfo = this.deviceDetectorService.getDeviceInfo();
  }
  /**
   * Se obtienen las url correspondientes para realizar la autenticacion
   * @param urlGeneral Variable de sesion en la cual se almacenan las url;
   * @param AutenticacionOK Variable que valida si el usuario se ha logueado o no
   * @autor Cristian Camilo Sanchez Rozo
   */

  ngOnInit() {
    if (this.variablesSesion.getData('AutenticacionOK') === 'true') {
      this.router.navigateByUrl('modulos');
    } else {
      this.loginService.getEnvironment().subscribe((env: Environment) => {
        this.environment = env;
        this.urlServicioGeneral = `${env.urlBase}/sysman-erp-servicio-administrador/servicio/gestionUrl?aplicacion=-1`;
        this.variablesSesion.setData('ipUsuario', '0.0.0.0');
        this.auditoriaServicio
          .getIp()
          .pipe(timeout(2000), retry(1))
          .subscribe((res: any) => {
            this.variablesSesion.setData('ipUsuario', res.ip);
          });
        sessionStorage.clear();
        this.variablesSesion.setData('AutenticacionOK', 'false');
        this.deviceInfo = this.deviceDetectorService.getDeviceInfo();

        const browserLang = this.translate.getBrowserLang();
        this.translate.use(browserLang || 'es');
        this.ocultarContrasena = true;
        this.generalService.obtenerDatos(this.urlServicioGeneral, null, true).subscribe((res: any) => {
          if (res['codigo'] == '0') {
            this.variablesSesion.setData('urlGeneral', res['cuerpo']);
          } else {
            this.translate.get('general.enumeradosjava').subscribe(() => {
              const variable = 'general.textosgenerales.txt_1_codigo';
              this.mensajeria.mensajeError(this.translate.instant(variable, { codigo: res['codigo'] }), res['mensaje']);
            });
          }
        });
      });
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.txtuser.nativeElement.focus();
    }, 300);
  }

  /**
   * Funcion que valida si el usuario no esta vacio ni nulo y llama el servicio
   * para obtener los datos asociados al usuario y se realiza la redireccion a
   * la vista autenticacion 2
   * @param txtUsuario Variable en la cual se guarda el username
   * @param obtenerDatosUsuarioAutenticacion Variable en la cual se obtiene la url para relizar la peticion
   * @param usuario Variable de sesion en la cual se almacena el username ingresado
   * @param nombreusuario Variable de sesion en la cual se almacena el nombre del usuario
   * @autor Cristian Camilo Sanchez Rozo
   */

  accionbutton() {
    switch (this.estado) {
      case 'usuario':
        if (this.txtUsuario != '' && this.txtUsuario != null && this.txtUsuario != undefined) {
          this.translate.get('general.textosgenerales').subscribe((x) => {
            this.servicioCargando.abrir(x.txt_47_validandoinformacion, x.txt_8_autenticacion);
            let obtenerDatosUsuarioAutenticacion = this.generalService.ObtenerUrl(
              'urlGeneral',
              'obtenerDatosUsuarioAutenticacion',
            );
            obtenerDatosUsuarioAutenticacion = obtenerDatosUsuarioAutenticacion + this.txtUsuario;
            this.generalService.obtenerDatos(obtenerDatosUsuarioAutenticacion, null).subscribe((res) => {
              if (res['codigo'] == '0') {
                const datosUsuario = res['cuerpo'][0].datosUsuario;
                const configCuenta = res['cuerpo'][0].configCuenta;
                this.variablesSesion.setData('usuario', this.txtUsuario);
                this.variablesSesion.setData('tema', configCuenta.tema ? configCuenta.tema.codigo : configCuenta.tema);
                this.variablesSesion.setData('nombreusuario', datosUsuario.nombre1);
                this.variablesSesion.setData('idioma', configCuenta.idioma ? configCuenta.idioma.codigo : 'es');
                this.variablesSesion.setData('id_usuario', datosUsuario.id);
                this.usuario = this.txtUsuario;
                this.nombreusuario = datosUsuario.nombre1;
                this.combocompanias_params = [{ id: 'user', valor: this.txtUsuario }];
                this.combocompanias_url = this.generalService.ObtenerUrl('urlGeneral', 'obtenerCompaniasAutenticacion');
                this.cantidadcompanias = datosUsuario.compania;
                this.validarcompania(datosUsuario.compania).then((res) => {
                  this.servicioCargando.cerrar();
                  if (res) {
                    this.estado = 'contrasena';
                  } else {
                    this.estado = 'compania';
                  }
                });
              } else {
                this.translate.get('general.textosgenerales').subscribe(() => {
                  this.mensajeria
                    .mensajeError(
                      this.translate.instant('general.textosgenerales.txt_1_codigo', { codigo: res['codigo'] }),
                      res['mensaje'],
                    )
                    .subscribe(() => {
                      this.txtUsuario = '';
                      this.servicioCargando.cerrar();
                    });
                });
              }
            });
          });
        } else {
          this.translate.get('general.textosgenerales').subscribe(() => {
            this.mensajeria
              .mensajeAdvertencia(
                'general.textosgenerales.txt_8_autenticacion',
                'general.textosgenerales.txt_9_usuariovacio',
              )
              .subscribe(() => {
                this.servicioCargando.cerrar();
                this.txtuser.nativeElement.focus();
              });
          });
        }
        break;
      case 'compania':
        if (this.datacompania) {
          this.variablesSesion.setData('compania', this.datacompania.id);
          this.variablesSesion.setData('codCompania', this.datacompania.codigo);
          this.variablesSesion.setData('nitcompania', this.datacompania.nitcompania);
          this.variablesSesion.setData('codigocompania', this.datacompania.codigo);
          this.variablesSesion.setData('urlLogo', this.datacompania.url_imagen);
          delete this.datacompania;
          this.estado = 'contrasena';
        } else {
          this.translate.get('general.textosgenerales').subscribe(() => {
            this.mensajeria.mensajeAdvertencia(
              'general.textosgenerales.txt_8_autenticacion',
              'general.textosgenerales.txt_10_companiavacia',
            );
          });
        }

        break;
      case 'contrasena':
        if (this.txtPass != '' && this.txtPass != null && this.txtPass != undefined) {
          this.translate.get('general.textosgenerales').subscribe((x) => {
            this.servicioCargando.abrir(x.txt_47_validandoinformacion, x.txt_8_autenticacion);

            this.variablesSesion.setData('codEntidad', this.environment.entidad);
            this.variablesSesion.setData(
              'equipoCliente',
              `${this.deviceInfo.os}-${this.deviceInfo.browser}-${this.deviceInfo.device}`,
            );
            this.loginService
              .login(
                this.variablesSesion.getData('usuario'),
                this.txtPass,
                this.variablesSesion.getData('compania'),
                this.variablesSesion.getData('codCompania'),
                this.variablesSesion.getData('codEntidad'),
                this.variablesSesion.getData('ipUsuario'),
                this.variablesSesion.getData('equipoCliente'),
              )
              .subscribe((response) => {
                if (response.codigo === 0) {
                  this.servicioCargando.cerrar();
                  this.variablesSesion.setData('AutenticacionOK', 'true');
                  this.variablesSesion.setData('environment', this.environment);

                  this.cargarGruposUsuario();

                  this.router.navigateByUrl('/modulos');
                } else {
                  this.servicioCargando.cerrar();
                  this.translate.get('general.textosgenerales').subscribe(() => {
                    this.mensajeria
                      .mensajeError(
                        this.translate.instant('general.textosgenerales.txt_1_codigo', { codigo: response['codigo'] }),
                        response['mensaje'],
                      )
                      .subscribe(() => {
                        this.txtPass = '';
                      });
                  });
                }
              });
          });
        } else {
          this.translate.get('general.textosgenerales').subscribe(() => {
            this.mensajeria
              .mensajeAdvertencia(
                'general.textosgenerales.txt_8_autenticacion',
                'general.textosgenerales.txt_11_contrasenavacia',
              )
              .subscribe(() => {
                this.txtP.nativeElement.focus();
              });
          });
        }
        break;
      default:
        break;
    }
  }

  return() {
    switch (this.estado) {
      case 'compania':
        this.estado = 'usuario';
        sessionStorage.clear();
        this.txtUsuario = '';
        this.generalService.obtenerDatos(this.urlServicioGeneral, null, true).subscribe((res) => {
          if (res['codigo'] == '0') {
            this.variablesSesion.setData('urlGeneral', res['cuerpo']);
          } else {
            this.translate.get('general.textosgenerales').subscribe(() => {
              this.mensajeria.mensajeError(
                this.translate.instant('general.textosgenerales.txt_1_codigo', { codigo: res['codigo'] }),
                res['mensaje'],
              );
            });
          }
        });
        break;
      case 'contrasena':
        this.txtPass = '';
        if (this.cantidadcompanias > 1) {
          this.variablesSesion.removeData('compania');
          this.variablesSesion.removeData('nitcompania');
          this.estado = 'compania';
        } else {
          sessionStorage.clear();
          this.txtUsuario = '';
          this.generalService.obtenerDatos(this.urlServicioGeneral, null, true).subscribe((res) => {
            if (res['codigo'] == '0') {
              this.variablesSesion.setData('urlGeneral', res['cuerpo']);
              this.estado = 'usuario';
            } else {
              this.translate.get('general.textosgenerales').subscribe(() => {
                this.mensajeria.mensajeError(
                  this.translate.instant('general.textosgenerales.txt_1_codigo', { codigo: res['codigo'] }),
                  res['mensaje'],
                );
              });
            }
          });
        }
        break;
      default:
        break;
    }
  }

  combocompanias($event: any) {
    this.datacompania = $event;
  }

  validarcompania(cantidadcompanias: any) {
    return new Promise((resolve, reject) => {
      if (parseInt(cantidadcompanias) != 0) {
        if (parseInt(cantidadcompanias) > 1) {
          resolve(false);
        } else {
          const usuario = 'user=' + this.usuario;
          this.generalService
            .obtenerDatos(this.generalService.ObtenerUrl('urlGeneral', 'obtenerCompaniasAutenticacion') + usuario, null)
            .subscribe((res) => {
              if (res['codigo'] == '0') {
                this.variablesSesion.setData('compania', res['cuerpo'][0].id);
                this.variablesSesion.setData('codCompania', res['cuerpo'][0].codigo);
                this.variablesSesion.setData('nitcompania', res['cuerpo'][0].nitcompania);
                this.variablesSesion.setData('codigocompania', res['cuerpo'][0].codigo);
                this.variablesSesion.setData('urlLogo', res['cuerpo'][0].url_imagen);

                resolve(true);
              } else {
                this.translate.get('general.textosgenerales').subscribe(() => {
                  this.mensajeria.mensajeError(
                    this.translate.instant('general.textosgenerales.txt_1_codigo', { codigo: res['codigo'] }),
                    res['mensaje'],
                  );
                });
              }
            });
        }
      } else {
        reject(false);
      }
    });
  }

  /**
   * Carga codigoMenu, urlAdminSistema y dispara el interceptor
   * que guarda grupos_usuario en sessionStorage.
   * Usa switchMap para aplanar las llamadas anidadas.
   */
  private cargarGruposUsuario(): void {
    const paramsMenus = [
      { id: 'idUsuario', valor: this.variablesSesion.getData('id_usuario') },
      { id: 'idMenu', valor: 0 },
      { id: 'idCompania', valor: this.variablesSesion.getData('compania') },
    ];
    const urlMenus = this.generalService.ObtenerUrl('urlGeneral', 'obtenerMenus', paramsMenus);

    this.generalService
      .obtenerDatos(urlMenus)
      .pipe(
        switchMap((resMenus: any) => {
          if (resMenus.codigo !== 0 || !resMenus.cuerpo) return EMPTY;
          const adminMenu = resMenus.cuerpo.find((m: any) => m.ruta?.includes('adminsistema'));
          if (!adminMenu) return EMPTY;

          const codigoMenu = adminMenu.codMenu;
          this.variablesSesion.setData('codigoMenu', codigoMenu);

          const urlGestionAdmin = `${this.environment.urlBase}/sysman-erp-servicio-administrador/servicio/gestionUrl?aplicacion=${codigoMenu}`;
          return this.generalService.obtenerDatos(urlGestionAdmin, null, true).pipe(
            switchMap((resAdmin: any) => {
              if (resAdmin.codigo !== 0) return EMPTY;
              this.variablesSesion.setData('urlAdminSistema', resAdmin.cuerpo);

              const param = [{ id: 'idUsuario', valor: this.variablesSesion.getData('id_usuario') }];
              const urlGrupos = this.generalService.ObtenerUrl('urlAdminSistema', 'obtenerGruposUsuario', param);
              const urlGruposFinal = `${urlGrupos}&pagInicio=0&pagTamanio=1000`;
              return this.Http.get(urlGruposFinal);
            }),
          );
        }),
      )
      .subscribe({
        // eslint-disable-next-line no-console
        next: () => console.log('Login -> grupos_usuario cargados.'),
        error: (err) => console.warn('Login -> Error cargando grupos:', err),
      });
  }
}
